import styled from 'styled-components';
import {ButtonBase} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import SearchInputIcon from '../../../../../stories/Icons/SearchInputIcon';
import {
  SectionHeader,
  FlexCentered,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const LocationMapContainer = styled.section(
  props => `
  width: 100%;
  margin: ${props.theme.spacing.xxlarge} auto 0;
  max-width: 120rem;
  border: 1px solid ${props.theme.colors.goBrandBlue.light};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  background: ${props.theme.colors.goWhite.base};
`,
);

export const LocationMapHeader = styled.div(
  props => `
  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};

`,
);

export const ContentContainer = styled.div(
  props => `
  display: flex;
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
  height: 42rem;
  position: relative;
`,
);

export const WhatIsAroundContainer = styled.div(
  props => `
  flex: 0.3;
  display: flex;
  flex-direction: column;
  border: 1px solid ${props.theme.colors.goBrandBlue.light};
  border-radius: 4px;
  overflow: auto;
`,
);

export const MapContainer = styled(FlexCentered)(
  props => `
  flex: ${props.flex || 0.7};
  height: 100%;
  padding: 0 ${props.theme.spacing.xlarge} 0 0;
`,
);

export const SomethingWentWrongText = styled(SectionHeader)(
  props => `
  padding-bottom:${props.theme.spacing.large};
  margin-left:${props.theme.spacing.xlarge};
`,
);

export const ReloadBtn = styled(ButtonBase)(
  props => `
  border: 0.1rem solid ${props.theme.colors.goBrandBlue.base};
  background:${props.theme.colors.goWhite.base};
  color: ${props.theme.colors.goBrandBlue.base};
  padding: ${props.theme.spacing.base} 0 ;
  width: 45%;
  margin-left:${props.theme.spacing.xlarge};
  &:hover{
    background:${props.theme.colors.goBrandBlue.base};
    color:${props.theme.colors.goWhite.base};
  }
  font-family:inherit;
  font-size:${props.theme.font.base};
`,
);

export const WhatIsAroundContainerHeader = styled.h3(
  props => `
  padding: ${props.theme.spacing.xlarge};
  background: ${props.theme.colors.goBrandBlue.light};
  font-size:${props.theme.font.custom(16)};
  font-family: Quicksand;
  font-weight :bold;
  flex: 0.06;
`,
);

export const PlacesListContainer = styled.div(
  props => `
  flex: 0.94;
  margin: 0 ${props.theme.spacing.large} 0;
`,
);

export const List = styled.ul(
  props => `
  flex: 1;
  list-style-type: none;
`,
);

export const ListItemWrapper = styled.div(
  props => `
  display: flex;
  align-items: baseline;
  padding: 0 0 ${props.theme.spacing.base};
`,
);

export const ListItem = styled.li(
  props => `
  cursor: pointer;
`,
);

export const DistanceText = styled.div(
  props => `
  margin: ${props.theme.spacing.xxsmall} 0 0 0;
`,
);

export const ListItemTextsContainer = styled.div(
  props => `
  margin: 0 0 0 ${props.theme.spacing.base};
`,
);

export const ListHeading = styled.h4(
  props => `
  font-weight :bold;
  
  font-size:${props.theme.font.custom(14)};
  margin: ${props.theme.spacing.large} 0;
`,
);

export const ListBoxWrapper = styled.aside(
  props => `
  display: flex;
  flex-direction: column;
  height: 100%;

  ${List}:nth-of-type(1) {
    border-bottom: 1px solid ${props.theme.colors.goBrandBlue.light};
  }
`,
);

export const GreenRound = styled.div(
  props => `
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props.active ? props.theme.colors.goYellow.base : props.theme.colors.goGreen.base};
`,
);

export const MapActionButton = styled(ButtonBase)(
  props => `
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large};
  background: white;
  color: black;
  box-shadow: ${props.theme.colors.downriver.medium} 0px 1px 4px -1px;
  font-family:inherit;
  font-size:${props.theme.font.base};
`,
);

export const MapActionButtonContainer = styled.div(
  props => `
  position: absolute;
  top: ${props.top || '9rem'};
  z-index: ${props.theme.misc.zIndex.small};
`,
);

export const SearchNearByLocation = styled.div(
  props => `
  display:flex;
  border: .1rem solid ${props.theme.colors.goBrandBlue.light};
  padding:${props.theme.spacing.large};
  border-radius: ${props.theme.misc.borderRadius.large};
  margin: ${props.theme.spacing.xxlarge} ${props.theme.spacing.xxlarge} 0 ${props.theme.spacing.xxlarge};
`,
);

export const LocationSearchInput = styled.input(
  props => `
  width:100%;
  border:none;
  font-size: ${props.theme.font.large};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
  background-color:${props.theme.colors.goWhite.base};
  ::placeholder {
    color: ${props.theme.colors.downriver.medium};
    font-size: ${props.theme.font.custom(16)};
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    overflow:visible;
  }
  &:focus{
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }
  `,
);

export const SearchIconWrap = styled(SearchInputIcon)(
  props => `
  width:2rem;
  height:2rem;
  margin-right: ${props.theme.spacing.large};
  fill:${props.theme.colors.downriver.medium};
`,
);

export const AutoSuggestOuterWrapper = styled.div(
  props => `
  display:flex;
  margin: 0 ${props.theme.spacing.xxlarge} ${props.theme.spacing.xxlarge};
  position:relative;
`,
);

export const AutoSuggestContainer = styled.div(
  props => `
  position:relative;
  width:28.6rem;
  padding: ${props.theme.spacing.small} ${props.theme.spacing.base};
  margin-right: ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.large};
  background:${props.theme.colors.goBrandBlue.light};
  border: .2rem solid ${props.theme.colors.goBrandBlue.light};
`,
);

export const TimeDistanceDurationWrapper = styled.div(
  props => `
  padding-top:${props.theme.spacing.base};
`,
);

export const LocationNameToolTip = styled.span(
  props => `
  visibility: hidden;
  background-color: ${props.theme.colors.downriver.medium};
  color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.large};
  padding: ${props.theme.spacing.small} ${props.theme.spacing.base};

  /* Position the tooltip */
  position: absolute;
  left:1.5rem;
  top:3rem;
  z-index:1;
`,
);

export const LocationName = styled.div(
  props => `
  color: ${props.theme.colors.goBrandBlue.base};
  font-size: ${props.theme.font.custom(14)};
  font-weight:bold;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width:22rem;
  cursor:pointer;
  &:hover > ${LocationNameToolTip} {
    visibility: visible;
  }
`,
);

export const LocationMapWrapper = styled(FlexCentered)(
  props => `
  padding-top:${props.theme.spacing.small};

`,
);

export const TimeDuration = styled.span(
  props => `
  color: ${props.theme.colors.downriver.medium};
  font-size: ${props.theme.font.custom(14)};
`,
);

export const DistanceDuration = styled(TimeDuration)(
  props => `
  padding-right: ${props.theme.spacing.small};
`,
);
